import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function newsContentGalleryBlock() {
	const blocks = document.querySelectorAll('.news-content-gallery-block');
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const el = block.querySelector('.gallery-swiper');
		if (!el) return;
		if (el.swiper) return;
		const wrapper = el.closest('.gallery-wrapper') || el.parentElement;
		const prevEl = wrapper?.querySelector('[data-js="gallery-prev"]');
		const nextEl = wrapper?.querySelector('[data-js="gallery-next"]');
		const slideCount = el.querySelectorAll('.swiper-slide').length;
		const hasMultipleSlides = slideCount > 1;

		block.classList.toggle('is-single-slide', !hasMultipleSlides);

		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: hasMultipleSlides ? 2 : 1,
			spaceBetween: hasMultipleSlides ? 30 : 0,
			loop: hasMultipleSlides,
			speed: 400,
			watchOverflow: true,
			allowTouchMove: hasMultipleSlides,
			navigation: {
				prevEl: hasMultipleSlides ? prevEl : null,
				nextEl: hasMultipleSlides ? nextEl : null,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: hasMultipleSlides ? 16 : 0,
				},
				768: {
					slidesPerView: hasMultipleSlides ? 2 : 1,
					spaceBetween: hasMultipleSlides ? 24 : 0,
				},
			},
		});
	});
}
